import { decode } from 'base-64';
import { apiConfig } from '@bonanza-social/toolkit/api';
import Config from '@bonanza-social/toolkit/config';
import {
  appAuthenticated,
  appOpened,
  startListening,
} from '@bonanza-social/toolkit/state';
import { logError } from '@bonanza-social/toolkit/logging';

type GeoFenceConfig = {
  apiToken: string;
  regionId: number;
};

export const loadGeoFence = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = 'https://d1ogq0nh9d1jss.cloudfront.net/sdk/latest.js';

    script.onload = resolve;
    script.onerror = reject;

    document.body.appendChild(script);
  });
};

type GeoFenceSdkType = typeof window.GeoFenceSDK;

let geoFenceSdk: GeoFenceSdkType;

startListening({
  actionCreator: appOpened,
  effect: async () => {
    await loadGeoFence();

    if (!Config.GEOFENCE_CONFIG) {
      return;
    }

    let geoFenceConfig: GeoFenceConfig;

    try {
      geoFenceConfig = JSON.parse(decode(Config.GEOFENCE_CONFIG));
    } catch (error) {
      logError('GeoFence config parse error', error);
      return;
    }

    geoFenceSdk = new GeoFenceSDK(geoFenceConfig);

    await geoFenceSdk.init();
  },
});

startListening({
  actionCreator: appAuthenticated,
  effect: async () => {
    const userId = await apiConfig.getUserId();

    if (!userId || !geoFenceSdk) {
      return;
    }

    await geoFenceSdk.ping({
      userId: userId.toString(),
      silent: true,
      skipLocation: true,
    });
  },
});
